export function Footer() {
  return (
    <footer className="bg-[#282828] border-t border-[#444340]">
      <div className="flex justify-center py-6">
        <a
          href="https://wordpress.com/?ref=footer_blog"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-sm uppercase tracking-wider font-['Libre_Baskerville'] hover:text-[#a8a6a1] transition-colors duration-200"
        >
          Blog at WordPress.com.
        </a>
      </div>
    </footer>
  );
}